import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";
export const appGroupIdCanvasWorkflowIdStepStepIdMessageCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/canvas/:workflow_id/step/:step_id/messages",
];
